// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file protobuf/journey/data/options/options.proto (package od_protos.journey.data.options, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions, MessageOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file protobuf/journey/data/options/options.proto.
 */
export const file_protobuf_journey_data_options_options: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_descriptor]);

/**
 * @generated from message od_protos.journey.data.options.Validation
 */
export type Validation = Message<"od_protos.journey.data.options.Validation"> & {
  /**
   * @generated from oneof od_protos.journey.data.options.Validation.rules
   */
  rules: {
    /**
     * @generated from field: od_protos.journey.data.options.Validation.StringRules string = 1;
     */
    value: Validation_StringRules;
    case: "string";
  } | {
    /**
     * @generated from field: od_protos.journey.data.options.Validation.EnumRules enum = 2;
     */
    value: Validation_EnumRules;
    case: "enum";
  } | {
    /**
     * @generated from field: od_protos.journey.data.options.Validation.MessageRules message = 3;
     */
    value: Validation_MessageRules;
    case: "message";
  } | {
    /**
     * @generated from field: od_protos.journey.data.options.Validation.IntRules int = 4;
     */
    value: Validation_IntRules;
    case: "int";
  } | { case: undefined; value?: undefined };

  /**
   * if set to true then the event will still be sent to Segment even if this field fails validation.
   *
   * @generated from field: bool ignore_validation_failures = 5;
   */
  ignoreValidationFailures: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.Validation.
 * Use `create(ValidationSchema)` to create a new message.
 */
export const ValidationSchema: GenMessage<Validation> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 0);

/**
 * @generated from message od_protos.journey.data.options.Validation.StringRules
 */
export type Validation_StringRules = Message<"od_protos.journey.data.options.Validation.StringRules"> & {
  /**
   * ip must be formatted like 0.0.0.0 and will be checked against a list of blocked IP addresses.
   *
   * @generated from field: bool ip = 1;
   */
  ip: boolean;

  /**
   * user_agent will be checked against a list of blocked user agents.
   *
   * @generated from field: bool user_agent = 2;
   */
  userAgent: boolean;

  /**
   * allow_list accepts comma separated strings and will reject events when the provided value is not in the allow list.
   *
   * @generated from field: string allow_list = 3;
   */
  allowList: string;

  /**
   * deny_list accepts comma separated strings and will reject events when the provided value is in the deny list.
   *
   * @generated from field: string deny_list = 4;
   */
  denyList: string;

  /**
   * Allows empty strings to be accepted (used when a required string field has to be changed to optional)
   *
   * @generated from field: bool optional = 5;
   */
  optional: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.Validation.StringRules.
 * Use `create(Validation_StringRulesSchema)` to create a new message.
 */
export const Validation_StringRulesSchema: GenMessage<Validation_StringRules> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 0, 0);

/**
 * @generated from message od_protos.journey.data.options.Validation.EnumRules
 */
export type Validation_EnumRules = Message<"od_protos.journey.data.options.Validation.EnumRules"> & {
  /**
   * Value must be a non-default enum value.
   *
   * @generated from field: bool required = 1;
   */
  required: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.Validation.EnumRules.
 * Use `create(Validation_EnumRulesSchema)` to create a new message.
 */
export const Validation_EnumRulesSchema: GenMessage<Validation_EnumRules> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 0, 1);

/**
 * @generated from message od_protos.journey.data.options.Validation.MessageRules
 */
export type Validation_MessageRules = Message<"od_protos.journey.data.options.Validation.MessageRules"> & {
  /**
   * When true none of the fields of the message or its children will be validated. ONLY USE ON MESSAGES DEFINED OUTSIDE OF JOURNEY.
   *
   * @generated from field: bool skip_validation = 1;
   */
  skipValidation: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.Validation.MessageRules.
 * Use `create(Validation_MessageRulesSchema)` to create a new message.
 */
export const Validation_MessageRulesSchema: GenMessage<Validation_MessageRules> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 0, 2);

/**
 * @generated from message od_protos.journey.data.options.Validation.IntRules
 */
export type Validation_IntRules = Message<"od_protos.journey.data.options.Validation.IntRules"> & {
  /**
   * Value must be non-zero.
   *
   * @generated from field: bool required = 1;
   */
  required: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.Validation.IntRules.
 * Use `create(Validation_IntRulesSchema)` to create a new message.
 */
export const Validation_IntRulesSchema: GenMessage<Validation_IntRules> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 0, 3);

/**
 * @generated from message od_protos.journey.data.options.CdpOptions
 */
export type CdpOptions = Message<"od_protos.journey.data.options.CdpOptions"> & {
  /**
   * @generated from field: od_protos.journey.data.options.CdpOptions.FieldPlacement placement = 1;
   */
  placement: CdpOptions_FieldPlacement;

  /**
   * name is used to override the field name instead of using the protobuf name.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from oneof od_protos.journey.data.options.CdpOptions.options
   */
  options: {
    /**
     * @generated from field: od_protos.journey.data.options.CdpOptions.MessageOptions message = 4;
     */
    value: CdpOptions_MessageOptions;
    case: "message";
  } | {
    /**
     * @generated from field: od_protos.journey.data.options.CdpOptions.EnumOptions enum = 5;
     */
    value: CdpOptions_EnumOptions;
    case: "enum";
  } | {
    /**
     * @generated from field: od_protos.journey.data.options.CdpOptions.MapOptions map = 6;
     */
    value: CdpOptions_MapOptions;
    case: "map";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message od_protos.journey.data.options.CdpOptions.
 * Use `create(CdpOptionsSchema)` to create a new message.
 */
export const CdpOptionsSchema: GenMessage<CdpOptions> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 1);

/**
 * @generated from message od_protos.journey.data.options.CdpOptions.MessageOptions
 */
export type CdpOptions_MessageOptions = Message<"od_protos.journey.data.options.CdpOptions.MessageOptions"> & {
  /**
   * @generated from field: od_protos.journey.data.options.CdpOptions.MessageOptions.Format format = 1;
   */
  format: CdpOptions_MessageOptions_Format;
};

/**
 * Describes the message od_protos.journey.data.options.CdpOptions.MessageOptions.
 * Use `create(CdpOptions_MessageOptionsSchema)` to create a new message.
 */
export const CdpOptions_MessageOptionsSchema: GenMessage<CdpOptions_MessageOptions> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 1, 0);

/**
 * @generated from enum od_protos.journey.data.options.CdpOptions.MessageOptions.Format
 */
export enum CdpOptions_MessageOptions_Format {
  /**
   * @generated from enum value: NOT_SPECIFIED = 0;
   */
  NOT_SPECIFIED = 0,

  /**
   * JSON_OBJECT nests the message's content using the JSON field names. Maps cannot be used within nested objects.
   *
   * @generated from enum value: JSON_OBJECT = 1;
   */
  JSON_OBJECT = 1,
}

/**
 * Describes the enum od_protos.journey.data.options.CdpOptions.MessageOptions.Format.
 */
export const CdpOptions_MessageOptions_FormatSchema: GenEnum<CdpOptions_MessageOptions_Format> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_options_options, 1, 0, 0);

/**
 * @generated from message od_protos.journey.data.options.CdpOptions.EnumOptions
 */
export type CdpOptions_EnumOptions = Message<"od_protos.journey.data.options.CdpOptions.EnumOptions"> & {
  /**
   * @generated from field: bool omit_default_value = 1;
   */
  omitDefaultValue: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.CdpOptions.EnumOptions.
 * Use `create(CdpOptions_EnumOptionsSchema)` to create a new message.
 */
export const CdpOptions_EnumOptionsSchema: GenMessage<CdpOptions_EnumOptions> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 1, 1);

/**
 * @generated from message od_protos.journey.data.options.CdpOptions.MapOptions
 */
export type CdpOptions_MapOptions = Message<"od_protos.journey.data.options.CdpOptions.MapOptions"> & {
  /**
   * Extract ad trackers (e.g. gclid) from map and add them to context.adTrackers.
   *
   * @generated from field: bool extract_ad_trackers = 1;
   */
  extractAdTrackers: boolean;
};

/**
 * Describes the message od_protos.journey.data.options.CdpOptions.MapOptions.
 * Use `create(CdpOptions_MapOptionsSchema)` to create a new message.
 */
export const CdpOptions_MapOptionsSchema: GenMessage<CdpOptions_MapOptions> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_options_options, 1, 2);

/**
 * @generated from enum od_protos.journey.data.options.CdpOptions.FieldPlacement
 */
export enum CdpOptions_FieldPlacement {
  /**
   * PROP is the default and it is used for properties describing the event.
   *
   * @generated from enum value: PROP = 0;
   */
  PROP = 0,

  /**
   * Trait's describe the customer and are relevant beyond a single event (e.g. name, email).
   *
   * @generated from enum value: TRAIT = 1;
   */
  TRAIT = 1,

  /**
   * Extra context is used to provide additional metadata. Should only be used in Sources.
   *
   * @generated from enum value: EXTRA_CONTEXT = 2;
   */
  EXTRA_CONTEXT = 2,

  /**
   * Standardized fields have their name and placement hard-coded and do not rely on reflection.
   *
   * @generated from enum value: STANDARDIZED = 3;
   */
  STANDARDIZED = 3,
}

/**
 * Describes the enum od_protos.journey.data.options.CdpOptions.FieldPlacement.
 */
export const CdpOptions_FieldPlacementSchema: GenEnum<CdpOptions_FieldPlacement> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_options_options, 1, 0);

/**
 * @generated from extension: od_protos.journey.data.options.Validation validation = 50571;
 */
export const validation: GenExtension<FieldOptions, Validation> = /*@__PURE__*/
  extDesc(file_protobuf_journey_data_options_options, 0);

/**
 * @generated from extension: od_protos.journey.data.options.CdpOptions cdp = 50572;
 */
export const cdp: GenExtension<FieldOptions, CdpOptions> = /*@__PURE__*/
  extDesc(file_protobuf_journey_data_options_options, 1);

/**
 * @generated from extension: bool send_identify_request = 50573;
 */
export const send_identify_request: GenExtension<MessageOptions, boolean> = /*@__PURE__*/
  extDesc(file_protobuf_journey_data_options_options, 2);

/**
 * comma separated list of lead traits to enrich
 *
 * @generated from extension: string enrich_with_lead_traits = 50574;
 */
export const enrich_with_lead_traits: GenExtension<MessageOptions, string> = /*@__PURE__*/
  extDesc(file_protobuf_journey_data_options_options, 3);

/**
 * indicates that the event should be enriched with property details
 *
 * @generated from extension: bool enrich_with_property_details = 50575;
 */
export const enrich_with_property_details: GenExtension<MessageOptions, boolean> = /*@__PURE__*/
  extDesc(file_protobuf_journey_data_options_options, 4);

/**
 * comma separated list of customer traits to enrich
 *
 * @generated from extension: string enrich_with_customer_traits = 50576;
 */
export const enrich_with_customer_traits: GenExtension<MessageOptions, string> = /*@__PURE__*/
  extDesc(file_protobuf_journey_data_options_options, 5);

